import { gql } from '@apollo/client';

export const GET_CATEGORY = gql`
    query searchCategory($field: String!, $value: String!) {
        searchCategory(input: { field: $field, value: $value }) {
            data {
                id
                name
                value
            }
        }
    }
`;
